<template>
  <el-dialog
    title="选择订单商品"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <!-- 这里放商品选择表格或其他内容 -->
    <div class="dialog-footer" slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ChooseStoreOrderCart',
  data() {
    return {
      dialogVisible: false,
      selectedProducts: []
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.selectedProducts = []
    },
    handleConfirm() {
      if (this.selectedProducts.length === 0) {
        this.$message.warning('请至少选择一件商品')
        return
      }
      this.$emit('chooseStoreOrderCart', this.selectedProducts)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>